import type {
  TermsSummaryApiResponse,
  WeekLessonsApiResponse
} from "@ts/interfaces/terms/api/termsApiInterface";
import { get } from "./httpClient";

export const getTermsSummary = async (
  gradeId: number
): Promise<TermsSummaryApiResponse> => {
  return await get<TermsSummaryApiResponse>(
    `/course/grade/${gradeId}/terms-summary`
  );
};

export const getWeekLessons = async (
  gradeId: number,
  termId: number,
  weekId: number
): Promise<WeekLessonsApiResponse> => {
  return await get<WeekLessonsApiResponse>(
    `/lesson/grade/${gradeId}/term/${termId}/week/${weekId}`
  );
};

export const termsApi = {
  getTermsSummary,
  getWeekLessons
};
